module.exports = __webpack_public_path__ + "static/img/rizhao.2a4bacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/rizhao.png
// module id = 1qBM
// module chunks = 93